module.exports = __webpack_public_path__ + "img/evolution1.63e23916.png";